import "./style.css"
const LoadingPage = () => {
    return (
        <div className="bg-containerBg h-dvh pt-[18px] lg:px-[19px] px-[14px] flex flex-col items-center w-full">
            <div className="w-screen h-full flex justify-center items-center px-[6rem]">
                <span className="loader"></span>
            </div>
        </div>
    )
}
export default LoadingPage